export interface PublicService {
  slug: string;
  name: string;
  shortDescription: string;
  longDescription: string;
  priceCents: number;
  currency: string;
  durationMinutes: number | null;
  maxQuestions: number;
  aiDisclosure: string;
  icon: string;
  category: string;
  orderIndex: number;
}

export const PUBLIC_SERVICES: PublicService[] = [
  {
    slug: "conseguir-empleo",
    name: "Conseguir empleo: orientación práctica con IA",
    shortDescription: "30 preguntas para mejorar tu CV, encontrar dónde postular, preparar entrevistas y organizar un plan laboral realista.",
    longDescription: "Un acompañamiento laboral asequible y concreto por chat con IA. Incluye hasta 30 preguntas para identificar tu objetivo, mejorar tu currículum y perfil profesional, adaptar postulaciones, preparar entrevistas, practicar respuestas y crear un plan de búsqueda de empleo. Recibirás consejos prácticos según tu país, experiencia y disponibilidad. Si deseas una reflexión espiritual, puedes pedirla como complemento opcional; la orientación laboral no depende de predicciones ni astrología. No incluye búsquedas de vacantes en tiempo real, postulaciones hechas por nosotros, videollamadas, redacción de documentos descargables ni garantía de contratación.",
    priceCents: 500000,
    currency: "CLP",
    durationMinutes: null,
    maxQuestions: 30,
    initialQuestions: ["¿En qué país y ciudad buscas empleo? ¿Buscas trabajo presencial, remoto o ambos?","¿Qué puesto u oficio deseas y qué experiencia, estudios o habilidades ya tienes? Puedes responder sin datos personales.","¿Cuál es tu mayor dificultad hoy: currículum, encontrar ofertas, entrevistas, falta de experiencia, cambio de rubro u otra?","¿Con qué urgencia necesitas ingresos, qué horarios puedes trabajar y cuál sería un próximo paso alcanzable?"],
    aiDisclosure: "Orientación laboral práctica mediante chat con IA: hasta 30 mensajes de consulta, por CLP 5.000. Incluye estrategias de CV, búsqueda, postulaciones y entrevistas; no garantiza empleo, no postula por ti ni ofrece vacantes verificadas en tiempo real. Perspectiva espiritual solo si la solicitas.",
    conversationGuidelines: "Priorizar consejos laborales racionales y concretos sobre cualquier lectura espiritual. Ayudar a CV, ATS, carta de presentación, vacantes, entrevistas, networking, negociación salarial y planificación semanal; ajustar por país, oficio, experiencia y urgencia. No inventar ofertas vigentes, requisitos legales, cifras salariales ni contactos. No prometer empleo. Orientación astrológica solamente si el usuario la pide, siempre separada de decisiones profesionales. Nunca solicitar datos natales ni usar historiales de otros servicios sin consentimiento.",
    icon: "BriefcaseBusiness",
    category: "empleo",
    orderIndex: 2,
  },
  {
    slug: "carta-astral-completa",
    name: "Consulta Astrológica Interactiva",
    shortDescription: "Orientación astrológica simbólica con IA mediante chat de hasta 10 preguntas. No incluye PDF ni carta natal calculada.",
    longDescription:
      "Consulta interactiva de hasta 10 preguntas mediante chat con IA para explorar tus inquietudes sobre vínculos, talentos, vocación y ciclos personales. Puedes compartir tu fecha, hora y lugar de nacimiento como contexto para una interpretación simbólica; este servicio no calcula posiciones planetarias, Ascendente, casas ni genera una rueda natal o informe PDF. Si buscas un mapa astronómico calculado y un documento descargable, elige la Carta Astral Premium en PDF.",
    priceCents: 1999000,
    currency: "CLP",
    durationMinutes: null,
    maxQuestions: 10,
    aiDisclosure:
      "Respuestas generadas por IA para la reflexión personal: lectura simbólica por chat, sin cálculos astronómicos ni documento PDF.",
    icon: "Moon",
    category: "astrologia",
    orderIndex: 5,
  },
  {
    slug: "lectura-tarot",
    name: "Tarot: claridad para tus decisiones",
    shortDescription: "Explora amor, trabajo o una decisión importante con una lectura simbólica de tarot por chat con IA.",
    longDescription:
      "Lectura conversacional de tarot con IA. Puedes plantear hasta 12 preguntas para reflexionar sobre tus opciones en amor, trabajo o decisiones personales. La interpretación utiliza símbolos del tarot y tus respuestas como contexto: no es una sesión con tarotista humana, no incluye videollamada ni promete adivinar el futuro.",
    priceCents: 599000,
    currency: "CLP",
    durationMinutes: null,
    maxQuestions: 12,
    aiDisclosure:
      "Consulta por chat con inteligencia artificial, hasta 12 preguntas. Interpretación simbólica sin predicciones garantizadas ni atención humana en vivo.",
    icon: "Star",
    category: "videncia",
    orderIndex: 10,
  },
  {
    slug: "cristaloterapia",
    name: "Chakras y equilibrio personal",
    shortDescription: "Una pausa para explorar cómo te sientes y crear prácticas sencillas de calma, respiración y autocuidado.",
    longDescription:
      "Guía simbólica e interactiva con IA, de hasta 10 preguntas, para explorar tus emociones y el significado tradicional de los chakras. Podrás recibir sugerencias sencillas de respiración, meditación y autocuidado sin diagnósticos de desequilibrios, sin terapias energéticas realizadas a distancia y sin promesas de sanación.",
    priceCents: 499000,
    currency: "CLP",
    durationMinutes: null,
    maxQuestions: 10,
    aiDisclosure:
      "Guía simbólica por chat con IA, hasta 10 preguntas. No diagnostica, trata ni sustituye atención de salud física o mental.",
    icon: "Sparkles",
    category: "sanacion",
    orderIndex: 20,
  },
  {
    slug: "videncia",
    name: "Lectura intuitiva: nuevos caminos",
    shortDescription: "Ordena una situación de incertidumbre y contempla posibilidades con una lectura simbólica personalizada.",
    longDescription:
      "Conversación guiada con IA de hasta 12 preguntas para explorar alternativas, prioridades y posibles pasos cuando enfrentas un cambio. La lectura utiliza lenguaje intuitivo y espiritual como recurso de reflexión: no afirma poderes de videncia, no conoce hechos ocultos ni predice sucesos futuros.",
    priceCents: 599000,
    currency: "CLP",
    durationMinutes: null,
    maxQuestions: 12,
    aiDisclosure:
      "Lectura simbólica por chat con IA, hasta 12 preguntas. No hay vidente humana ni garantía de predicciones sobre el futuro.",
    icon: "Eye",
    category: "videncia",
    orderIndex: 30,
  },
  {
    slug: "amor-relaciones",
    name: "Amor y relaciones: claridad emocional",
    shortDescription: "Reflexiona sobre pareja, expareja o nuevos vínculos y encuentra preguntas útiles para decidir con calma.",
    longDescription:
      "Consulta conversacional con IA de hasta 14 preguntas centrada en vínculos, autoestima, comunicación y límites personales. Te ayuda a examinar distintos puntos de vista sin afirmar conocer lo que siente otra persona ni prometer reconciliaciones, retornos de pareja o decisiones ajenas.",
    priceCents: 699000,
    currency: "CLP",
    durationMinutes: null,
    maxQuestions: 14,
    aiDisclosure:
      "Orientación reflexiva por chat con IA, hasta 14 preguntas. No es terapia de pareja ni garantiza que otra persona actúe de cierta manera.",
    icon: "Heart",
    category: "amor",
    orderIndex: 40,
  },
  {
    slug: "ritual-personalizado",
    name: "Tu ritual simbólico personalizado",
    shortDescription: "Diseña una práctica simbólica para una intención personal con materiales sencillos y pasos seguros.",
    longDescription:
      "Diseño conversacional con IA, de hasta 16 preguntas, para crear un ritual simbólico de reflexión, gratitud o cierre de ciclos, adaptado a tus preferencias y materiales caseros. Incluye una secuencia de pasos y recomendaciones responsables; no implica envío de objetos, ejecución presencial del ritual ni efectos mágicos garantizados.",
    priceCents: 799000,
    currency: "CLP",
    durationMinutes: null,
    maxQuestions: 16,
    aiDisclosure:
      "Diseño simbólico guiado por IA mediante chat, hasta 16 preguntas. No se envían materiales ni se realiza el ritual por ti; no se garantizan resultados sobrenaturales.",
    icon: "Zap",
    category: "rituales",
    orderIndex: 50,
  },
];

export const SERVICE_SLUGS = PUBLIC_SERVICES.map((service) => service.slug);

export function getPublicServiceBySlug(slug?: string) {
  return PUBLIC_SERVICES.find((service) => service.slug === slug) ?? null;
}
